import moment from 'moment';

import { resolve } from './resolve-object-property';
import {
  sortingOrder,
  sortingAs,
  SortingAsType,
  sortingOrderType,
} from './constants';
import { IIndexSignature } from './types';

export const convertDateToNumber = (date: number[]) => {
  return Number(
    date[2] +
      date[1].toString().padStart(2, '0') +
      date[0].toString().padStart(2, '0')
  );
};

export const sortCallback =
  (
    sortBy: string | string[],
    sortingAsValue: SortingAsType,
    sortingOrderValue: sortingOrderType
  ) =>
  (
    firstItem: IIndexSignature<string | number>,
    secondItem: IIndexSignature<string | number>
  ) => {
    const sortBykey: string = Array.isArray(sortBy)
      ? sortBy.find((key) => resolve(key, firstItem)) || ''
      : sortBy;
    const firstItemValue = resolve(sortBykey, firstItem);
    const secondItemValue = resolve(sortBykey, secondItem);
    if (sortingAsValue === sortingAs.STRING) {
      if (firstItemValue < secondItemValue)
        return sortingOrderValue === sortingOrder.ASC ? 1 : -1;
      if (firstItemValue > secondItemValue)
        return sortingOrderValue === sortingOrder.ASC ? -1 : 1;
      return 0;
    }
    if (sortingAsValue === sortingAs.DATE) {
      const firstDate = moment(firstItemValue).utc();
      const secondDate = moment(secondItemValue).utc();
      return sortingOrderValue === sortingOrder.ASC
        ? moment(firstDate).diff(secondDate)
        : moment(secondDate).diff(firstDate);
    }
    return sortingOrderValue === sortingOrder.ASC
      ? +(firstItemValue || 0) - +(secondItemValue || 0)
      : +(secondItemValue || 0) - +(firstItemValue || 0);
  };
